import React, { useState } from "react";
import { Divider } from "antd";

const PurchaseDetails = ( props ) => {
   const { selectedItem } = props;
     const { price, currency, points } = selectedItem || {};

  return (
    <div className="space-y-4 pt-4">
      <div className="flex flex-col gap-6 rounded-xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white">
        <div className="pb-6 p-5">
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-[13px]">Purchase Amount</span>
              <span className="font-semibold text-[18px] text-emerald-600">{price} {currency}</span>
            </div>
              <Divider className="my-4" />
            <div className="flex items-center justify-between">
              <span className="text-[13px]">Total Points</span>
              <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 text-xs font-medium gradient emerald text-white">
                {points} credits
              </span>
            </div>
          </div>
        </div>
      </div>
        <div className="flex flex-col gap-6 rounded-xl border border-blue-200 bg-blue-50/50">
          <div className="pb-6 p-4">
            <p className="text-[12px] text-blue-700">Points will be added to your company balance immediately and can be awarded to team members as gift credits.</p>
          </div>
      </div>
    </div>
  );
};

export default PurchaseDetails;
